import MenuItem from "@mui/material/MenuItem";
import Select, { SelectProps } from "@mui/material/Select";
import { ForwardRefRenderFunction, forwardRef, memo } from "react";

export interface GenDropDownItem {
  label: string;
  value: string;
}

export type GenDropDownProps = SelectProps & {
  items: GenDropDownItem[];
  placeholder?: string;
};

export const GenDropDown: ForwardRefRenderFunction<
  SelectProps,
  GenDropDownProps
> = (props, ref) => {
  const { items, placeholder, defaultValue, ...otherProps } = props;

  return (
    <>
      <Select
        fullWidth
        defaultValue={defaultValue}
        sx={{
          "& .MuiSelect-outlined": { padding: 1 },
          marginTop: 1,
          marginBottom: 0.5,
        }}
        {...otherProps}
      >
        <MenuItem key={`default-choice`} color="secondary.light" value="">
          {placeholder || ""}
        </MenuItem>
        {items.map(({ label, value }, i) => (
          <MenuItem key={`${label}-${value}-choice-${i}`} value={value}>
            {label}
          </MenuItem>
        ))}
      </Select>
    </>
  );
};

export default memo(forwardRef(GenDropDown));
